import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-followup-exam',
  templateUrl: './followup-exam.component.html',
  styleUrls: ['./followup-exam.component.css']
})
export class FollowupExamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/patients/followup-exam.component.ts